import TeaserList from './TeaserList';
import { TEASER } from './teaser.navigation';

const teaserRoute = { ...TEASER, component: TeaserList };

export default teaserRoute;
